import React from 'react';
import PropTypes from 'prop-types';
import * as classes from './classes.module.scss';
import Pin from '../assets/pin';
import Pinned from '../assets/pinned';

const PinButton = ({ pinned, togglePin }) => (
  <div className={ classes.pin }>
    <button type="button" onClick={ togglePin }>
      { pinned ? <Pinned fill="#000" /> : <Pin fill="#000" /> }
    </button>
  </div>
);

PinButton.propTypes = {
  pinned: PropTypes.bool.isRequired,
  togglePin: PropTypes.func.isRequired
};

export default PinButton;
